import { useContext } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import { customersContext } from '../CustomersContext';
import SearchIcon from '@material-ui/icons/Search';
import { FilterContainer } from 'components';

let Filters = () => {
    let { search, updateSearch, doSearch } = useContext(customersContext);

    return (
        <FilterContainer onSubmit={() => doSearch(search)}>
            <Grid item>
                <TextField
                    name="search"
                    label="Email"
                    value={search.email}
                    onChange={(e) => updateSearch({
                        ...search,
                        email: e.target.value
                    })}
                />
            </Grid>

            <Grid item>
                <TextField
                    name="search"
                    label="Company"
                    value={search.company}
                    onChange={(e) => updateSearch({
                        ...search,
                        company: e.target.value
                    })}
                />
            </Grid>

            <Grid item>
                <TextField
                    name="search"
                    label="M3 Id"
                    value={search.m3Id}
                    onChange={(e) => updateSearch({
                        ...search,
                        m3Id: e.target.value
                    })}
                />
            </Grid>
            <Grid item>
                <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                >
                    <SearchIcon />
                </Button>
            </Grid>

        </FilterContainer>


    );
}

export default Filters;